import { render, staticRenderFns } from "./linkBankAccounts.vue?vue&type=template&id=f9f43ca4&"
import script from "./linkBankAccounts.vue?vue&type=script&lang=js&"
export * from "./linkBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports